import { NextPage } from 'next';
import OpenSourceLibrariesPage from '@sy/app-client/src/ssrAdapter/pages/OpenSourceLibrariesPage';

import MarketingTemplate from '~/components/templates/MarketingTemplate';
import buildMetatadata from '~/utils/buildMetadata';
import { getMarketingNavigation } from '~/utils/getNavigation';
import { translate, buildGetServerSideProps } from '../getServerSideProps';
import type { CommonContext, InferProps } from '../getServerSideProps';

const OpenSourceLibraries: NextPage<InferProps<typeof getServerSideProps>> = ({
	featureFlags,
	navigation,
	user,
}) => (
	<MarketingTemplate
		activePage="/open-source-libraries"
		featureFlags={featureFlags}
		navigation={navigation}
		user={user}
	>
		<OpenSourceLibrariesPage />
	</MarketingTemplate>
);

const customServerSideProps = async (context: CommonContext) => {
	const { featureFlags, locale, query } = context;

	return {
		props: {
			metadata: buildMetatadata({
				title: translate(locale, 'common.v2.footer.openSourceLibraries'),
			}),
			navigation: await getMarketingNavigation({ featureFlags, locale, query }),
		},
	};
};

export const getServerSideProps = buildGetServerSideProps({
	customServerSideProps,
	translationNamespaces: ['common'],
});

export default OpenSourceLibraries;
